import { render, staticRenderFns } from "./MerchantNotice.vue?vue&type=template&id=9eadf8e0&scoped=true&"
import script from "./MerchantNotice.vue?vue&type=script&lang=js&"
export * from "./MerchantNotice.vue?vue&type=script&lang=js&"
import style0 from "./MerchantNotice.vue?vue&type=style&index=0&id=9eadf8e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eadf8e0",
  null
  
)

export default component.exports